<mat-card class="gallery-card">
  <mat-card-header>
    <mat-card-title>Afbeeldingen</mat-card-title>
  </mat-card-header>

  <div class="gallery-wrapper">
    <div class="overlay" *ngIf="loading$ | async">
      <mat-spinner diameter="60"></mat-spinner>
    </div>

    <lightgallery [settings]="settings" class="image-gallery" *ngIf="images$ | async as imgs">
      <ng-container *ngIf="! (loading$ | async)">
        <div *ngIf="imgs.length === 0" class="empty-state">
          Geen afbeeldingen gevonden
        </div>
        <img
          *ngFor="let img of imgs; let i = index; trackBy: trackByIndex"
          [src]="img"
          alt="Plant afbeelding"
          class="gallery-image"
          loading="lazy"
        />
      </ng-container>
    </lightgallery >

    <input
      #fileInput
      type="file"
      accept="image/*"
      capture="environment"
      hidden
      (change)="onFileSelected($event)"
    />

    <button
      *ngIf="canUpload"
      mat-fab
      color="accent"
      class="upload-btn"
      (click)="fileInput.click()"
      aria-label="Upload afbeelding"
    >
      <mat-icon>cloud_upload</mat-icon>
    </button>
  </div>
</mat-card>
